import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function getSystemSettings() {
    return await request('/api/systemsettings', {}, HttpMethod.GET);
}

export async function updateSystemSettings(data) {
    return await request('/api/systemsettings', data, HttpMethod.POST);
}